// Lightweight theme helper. Stored per-device in localStorage; the global
// API value is just the "default for new browsers" — once the user picks one
// here it stays that way until they change it again.

const KEY = "ui_theme";
const VALID = new Set(["dark", "light", "auto"]);

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(KEY);
    return VALID.has(v) ? v : null;
  } catch (_e) { return null; }
}

export function setStoredTheme(t) {
  try {
    if (VALID.has(t)) localStorage.setItem(KEY, t);
  } catch (_e) { /* ignore */ }
}

function resolveTheme(t) {
  if (t === "auto") {
    try {
      const mq = window.matchMedia("(prefers-color-scheme: light)");
      return mq.matches ? "light" : "dark";
    } catch (_e) { return "dark"; }
  }
  return t === "light" ? "light" : "dark";
}

export function applyTheme(t) {
  const resolved = resolveTheme(t);
  try {
    const root = document.documentElement;
    root.setAttribute("data-theme", resolved);
    root.classList.toggle("theme-light", resolved === "light");
    root.classList.toggle("theme-dark", resolved === "dark");
  } catch (_e) { /* ignore */ }
}

export function initTheme() {
  const t = getStoredTheme() || "dark";
  applyTheme(t);
  // React to OS changes when in auto mode
  try {
    const mq = window.matchMedia("(prefers-color-scheme: light)");
    const handler = () => { if ((getStoredTheme() || "dark") === "auto") applyTheme("auto"); };
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else if (mq.addListener) mq.addListener(handler);
  } catch (_e) { /* ignore */ }
}
